import InlineChromiumBugfix from "@/components/InlineChromiumBugFix";
import { createCodingKey } from "@/data-models/value-models/createCodeKey";
import { CodingModel } from "@/data-models/value-models/structs";
import {
  IHumanReadableCoding,
  codingToConcept,
} from "@/data-models/value-models/types";
import { RenderTypedElementProps } from "@/editor/TypedElement";
import { Path, Transforms } from "slate";
import { v4, v5 } from "uuid";
import {
  ReactEditor,
  useFocused,
  useReadOnly,
  useSelected,
  useSlateStatic,
} from "slate-react";
import { create } from "superstruct";
import { CHIP_INPUT_ELEMENT } from "./consts";
import { IAddChipButtonElement, IChipInputElement } from "./types";
import AddChip from "@/components/inputs/MultipleChoice/AddChip";

export interface RenderChipInputElementProps extends RenderTypedElementProps {
  element: IAddChipButtonElement;
}
const CHIP_NS = v4();

const DEFAULT_VALUESET =
  "http://tiro.health/fhir/ValueSet/snomed-ct-auto-generated";
function RenderAddChipButtonElement({
  element,
  attributes,
  children,
}: RenderChipInputElementProps) {
  const { valueSet = DEFAULT_VALUESET } = element;
  const readOnly = useReadOnly();
  const editor = useSlateStatic();
  const focused = useFocused();
  const selected = useSelected();
  const active = focused && selected;
  const handleCodeChange = async (code: IHumanReadableCoding) => {
    const path = ReactEditor.findPath(editor, element);
    const chip: IChipInputElement = {
      type: CHIP_INPUT_ELEMENT,
      name: v5(createCodingKey(create(code, CodingModel)), CHIP_NS),
      code: codingToConcept(code),
      children: [{ text: "" }],
    };
    Transforms.insertNodes(
      editor,
      { children: [{ text: "" }, chip, { text: "" }] },
      { at: Path.parent(path), mode: "highest" }
    );
  };
  return (
    <span {...attributes} tabIndex={-1}>
      <InlineChromiumBugfix />
      <AddChip
        valueSet={valueSet}
        active={active}
        disabled={!readOnly}
        onCodeSelect={handleCodeChange}
      />
      {children}
      <InlineChromiumBugfix />
    </span>
  );
}

export default RenderAddChipButtonElement;
